import { render, staticRenderFns } from "./AknTextarea.vue?vue&type=template&id=29d15bf8&scoped=true&"
import script from "./AknTextarea.vue?vue&type=script&lang=js&"
export * from "./AknTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AknTextarea.vue?vue&type=style&index=0&id=29d15bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d15bf8",
  null
  
)

export default component.exports